import { render, staticRenderFns } from "./AdminAuth.vue?vue&type=template&id=6851a407&scoped=true"
import script from "./AdminAuth.vue?vue&type=script&lang=js"
export * from "./AdminAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6851a407",
  null
  
)

export default component.exports